<div class="notice" *ngIf="!canRequestTokensForContract">
  <div class="notice-body">
    Tokens are not available for this contract. Please select a CloneManager, VA or FSBlocker contract.
  </div>
</div>
<div class="wrapper">
    <div class="notice notice-error" *ngIf="checkTokens()">
    <div class="notice-body">
      You do not have enough tokens available. Please purchase more tokens or choose a different combination.
    </div>
  </div>
  <div class="notice" *ngIf="isRABulkSelected && !checkTokens()">
    <div class="notice-body">
      Unlimited Recovery Assurance tokens enabled.
    </div>
  </div>
  <h4>{{ isSiteLicensed ? 'Available Site Licences:' : isFSBlocker ? 'Available Capacity:' : 'Available Tokens:' }}</h4>
  <form [formGroup]="RequestTokensForm">
    <div class="form-group row mb-2" *ngIf="isSiteLicensed">
      <span class="col-sm-2 col-form-label">Site Licences</span>
      <div class="col-sm-10">
        <span class="form-text">{{ contract?.siteLicences }}</span>
      </div>
    </div>
    <div class="form-group row mb-2" *ngIf="!isSiteLicensed && !isFSBlocker">
      <span class="col-sm-2 col-form-label">{{ isVA ? 'Selected Type' : 'Full' }}</span>
      <div class="col-sm-10">
        <span class="form-text">{{
          isVA ? get_max() : contract?.cloneTokens?.available
        }}</span>
      </div>
    </div>
    <div class="form-group row mb-2" *ngIf="!isSiteLicensed && isFSBlocker">
      <span class="col-sm-2 col-form-label">Capacity (TB)</span>
      <div class="col-sm-10">
        <span class="form-text">{{ contract?.capacity?.available }}</span>
      </div>
    </div>

    <hr />
    <div class="notice notice-error" *ngIf="error">
      <div class="notice-body">
        Failed to generate token code.<br>
        {{ error?.description }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <div class="col-sm-2 col-form-label" [ngClass]="{
          'text-danger font-weight-bold':
            f.hostIp.invalid && (f.hostIp.dirty || f.hostIp.touched)
        }">IP Address <span class="text-danger">*</span></div>
      <div class="col-sm-10">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>IP Address</mat-label>
          <input matInput type="text" id="hostIp" formControlName="hostIp" />
          <mat-hint align="start">The IP address of the {{ tokenTargetSystemName }}</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class="form-group row mb-2">
      <div class="col-sm-2 col-form-label">Hostname <span class="text-danger">*</span></div>
      <div class="col-sm-10">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Hostname</mat-label>
          <input matInput type="text" id="hostName" formControlName="hostName" />
          <mat-hint align="start">The hostname of the {{ tokenTargetSystemName }}</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class="form-group row mb-2">
      <div class="col-sm-2 col-form-label" *ngIf="!isFSBlocker">Token Type <span class="text-danger">*</span></div>
      <div class="col-sm-10" *ngIf="!isFSBlocker">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Token Type</mat-label>
          <mat-select id="tokenType" formControlName="tokenType" (selectionChange)="tokentypeChange()">
            <ng-container *ngIf="!isVA">
              <mat-option value="Full">Full</mat-option>
            </ng-container>
            <ng-container *ngIf="isVA">
              <mat-option value="Upgrade">Upgrade</mat-option>
              <mat-option value="Staging">Staging Upgrade</mat-option>
              <mat-option value="RA">Recovery Assurance</mat-option>
              <mat-option value="RABulk">Recovery Assurance Unlimited</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="form-group row mb-2" *ngIf="!isRABulkSelected">
      <div class="col-sm-2 col-form-label" [ngClass]="{
          'text-danger font-weight-bold':
            (f.tokenCount.invalid &&
              (f.tokenCount.dirty || f.tokenCount.touched)) ||
            validateTokenCount()
      }">{{ isFSBlocker ? 'Capacity (TB)' : 'Quantity' }} <span class="text-danger">*</span></div>
      <div class="col-sm-10">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ isFSBlocker ? 'Capacity (TB)' : 'Quantity' }}</mat-label>
          <input matInput type="number" id="tokenCount" formControlName="tokenCount" min="0" [max]="get_max()" />
        </mat-form-field>
      </div>
    </div>
    <div class="form-group row mb-2">
      <div class="col-sm-2 col-form-label" [ngClass]="{
          'text-danger font-weight-bold':
            f.signature.invalid && (f.signature.dirty || f.signature.touched)
      }">Signature <span class="text-danger">*</span></div>
      <div class="col-sm-10">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Signature</mat-label>
          <input matInput type="text" id="signature" placeholder="xxxxxxxx-xxxxxxxx-xxxxxxxx-xxxxxxxx" formControlName="signature" />
          <mat-hint align="start" *ngIf="isSiteLicensed">Signature validation is skipped for site licensed contracts</mat-hint>
          <mat-hint align="start" *ngIf="!isSiteLicensed">The signature of the {{ tokenTargetSystemName }} (format xxxxxxxx-xxxxxxxx-xxxxxxxx-xxxxxxxx)</mat-hint>
          <mat-hint align="end" [ngClass]="signatureCountClass">{{ signatureLength }}/35</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class="form-group row mb-2">
      <div class="col-sm-9 text-center pt-3">
        <button mat-flat-button color="primary" type="submit" id="request-token-button" (click)="requestToken()" [disabled]="requestTokenDisabled()">
          <mat-spinner *ngIf="requesting" diameter="20" mode="indeterminate"></mat-spinner>
          {{ requesting ? 'Requesting' : 'Request Token' }}
        </button>
      </div>
    </div>
  </form>
</div>
<ng-template #requestModal>
  <div class="mat-dialog-container">
    <h2 mat-dialog-title id="request-token-dialog-title" class="dialog-title">
      <span class="title-text">Request Token Successful</span>
      <button mat-icon-button type="button" class="close-icon" aria-label="Close" id="request-token-dismiss-button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>
      <div class="notice">
        <div class="notice-body">Successfully requested tokens.</div>
      </div>

      <table class="table table-sm table-bordered token-result-table">
        <thead>
          <tr>
            <th>Hostname</th>
            <ng-container *ngIf="!isFSBlocker">
              <ng-container *ngIf="!isVA">
                <th>Clone Code</th>
                <th>Sync Code</th>
              </ng-container>
              <ng-container *ngIf="isVA">
                <th>Activation Code</th>
                <th>Upgrade Token</th>
                <th>Staging Token</th>
                <th>Recovery Assurance Token</th>
                <th>Recovery Assurance Unlimited Token</th>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="isFSBlocker">
              <th>Activation Code</th>
              <th>Capacity Token</th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let token of tokenResponse;">
            <td class="token-hostname-cell">{{ token.hostname }}</td>
            <ng-container *ngIf="!isFSBlocker">
              <ng-container *ngIf="!isVA">
                <td><code>{{ token.cloneCode }}</code></td>
                <td><code>{{ token.syncCode }}</code></td>
              </ng-container>
              <ng-container *ngIf="isVA">
                <td><code>{{ token.activationCode }}</code></td>
                <td><code>{{ token.upgradeCode }}</code></td>
                <td><code>{{ token.stagingCode }}</code></td>
                <td><code>{{ token.raCode }}</code></td>
                <td><code>{{ token.raBulkCode }}</code></td>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="isFSBlocker">
              <td><code>{{ token.activationCode }}</code></td>
              <td><code>{{ token.tokenCode }}</code></td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="accent" type="button" id="request-token-copy-details-button" (click)="copyTokenDetails()">Copy
        Details</button>
      <button mat-raised-button color="primary" type="button" id="request-token-close-button" (click)="closeDialog()">
        Close
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
